module.exports = __webpack_public_path__ + "static/media/service6.fb6a8c8a.png";